

export default class UI5CalendarDayDnd {
    constructor(props) {
        this.props = props
    }

    canDrop(superRes, draggedItem) {
        let dropAllowed = !this.props.data.isDisabled

        return superRes && dropAllowed
    }

    onDrop(draggedItem, dropResult) {
        return _.assign({}, dropResult, {
            dropped             : true,
            calendarDayMoment   : this.props.data.moment
        })
    }
}